import { render } from "./BoxIcon.vue?vue&type=template&id=c140e946"
import script from "./BoxIcon.vue?vue&type=script&lang=js"
export * from "./BoxIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__